import {persistReducer} from 'redux-persist'
import {initialValuesProducts, ProductsObjectInterface} from '../@contexts'
import storage from 'redux-persist/lib/storage'

export const actionTypes = {
    SetProductsActive: '[SET_PRODUCTS_ACTIVE] Action',
    ClearProductsActive: '[CLEAR_PRODUCTS_ACTIVE] Action',
}

export const actions = {
    setProductsActive: (products: ProductsObjectInterface) => ({
        type: actionTypes.SetProductsActive,
        payload: products,
    }),
    clearProductsActive: () => ({type: actionTypes.ClearProductsActive}),
}


export const reducer = persistReducer(
    {
        storage, key: 'v100-demo1-products',
        whitelist: [
            "callTracking",
            "contacts",
            "conversionClicks",
            "documents",
            "mailing",
            "reputation",
            "sav",
            "statistics",
            "updatePlugins",
            "webForms"
        ],
    },
    (state: ProductsObjectInterface = initialValuesProducts.products, action: any) => {
        switch (action.type) {
            case actionTypes.SetProductsActive:
                return { ...state, ...action.payload };
            case actionTypes.ClearProductsActive:
                return initialValuesProducts;
            default:
                return state;
        }
    },
)